<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2toc"><a id="page_3">CONTENTS</a></h2><a id="page_3">
</a><p class="tocc"><a id="page_3"></a><a href="#/xhtml/intro"><span class="txbf">INTRODUCTION</span></a></p>
<p class="toc"><a href="#/xhtml/ch01"><span class="txbf">CHAPTER 1:</span> Setting Yourself Up for Success</a></p>
<p class="toc"><span href="#/xhtml/ch02" title="Link target outside of Sample"><span class="txbf">CHAPTER 2:</span> Staying Productive at Work</span></p>
<p class="toc"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="txbf">CHAPTER 3:</span> Being Productive When You Work from Home</span></p>
<p class="toc"><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="txbf">CHAPTER 4:</span> Productive Business Travel</span></p>
<p class="toc"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="txbf">CHAPTER 5:</span> Having Productive Meetings</span></p>
<p class="toc"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="txbf">CHAPTER 6:</span> Technology and Tools</span></p>
<p class="toc"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="txbf">CHAPTER 7:</span> Maintaining a Work/Life Balance</span></p>
<p class="tocc"><span href="#/xhtml/authorbio" title="Link target outside of Sample"><span class="txbf">ABOUT THE AUTHOR</span></span></p>
<p class="tocc"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="txbf">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?c0caf700